/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import useCustomMutationReactQuery from '../generalHooks/useCustomMutationReactQuery'
import _ from 'lodash'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import { getBlogList, getDetailBlog, getFeaturedBlogList } from '@/utility/apiProcess/blog'

const useBlogQuery = () => {
  // get Blog list
	const [blogList, setBlogList] = useState<any>([])
	const [blogPageInfo, setBlogPageInfo] = useState<any>({})
  const {
		isLoading: loadingBlogList,
		return_data: rawBlogList,
		startFetch: startBlogList,
	} = useCustomMutationReactQuery(getBlogList, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(rawBlogList)) {
			const data:any = []
			rawBlogList.data.data.map((item: any, index:number) => {
				data.push({
					id: item.id,
					title: item.title,
					img: item.image_url,
					date: dayjs(item.publish_date).format('DD MMM YYYY'),
					description: item.description,
					author: item.author_name,
					type: item.type_name,
					slug: item.slug
				})
			})

			setBlogList(data)
			setBlogPageInfo(rawBlogList.data.infoPage)
		}
	},[rawBlogList])

	// get featured blog
	const [featuredBlog, setFeaturedBlog] = useState<any>([])
  const {
		isLoading: loadingFeaturedBlogList,
		return_data: rawFeatureBlogList,
		startFetch: startFeatureBlogList,
	} = useCustomMutationReactQuery(getFeaturedBlogList, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(rawFeatureBlogList)) {
			const dataFeatured:any = []
			rawFeatureBlogList.data.data.map((item: any, index:number) => {
				dataFeatured.push({
					id: item.id,
					title: item.title,
					img: item.image_url,
					date: dayjs(item.publish_date).format('DD MMM YYYY'),
					description: item.description,
					author: item.author_name,
					type: item.type_name,
					slug: item.slug
				})
			})

			setFeaturedBlog(dataFeatured)
		}
	},[rawFeatureBlogList])
  
	// get detail blog
	const [blogDetail, setBlogDetail] = useState<any>({})
	const [relatedBlogDetail, setRelatedBlogDetail] = useState<any>([])
	const {
		isLoading: loadingBlogDetail,
		return_data: blogDetailRaw,
		startFetch: startBlogDetail,
	} = useCustomMutationReactQuery(getDetailBlog, {
		onError: (error: Error) => console.log(error),
		isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(blogDetailRaw)) {
			const relatedBlog:any = []
			blogDetailRaw.data.data.other.map((item: any, index:number) => {
				relatedBlog.push({
					id: item.id,
					title: item.title,
					img: item.image_url,
					date: dayjs(item.publish_date).format('DD MMM YYYY'),
					description: item.description,
					author: item.author_name,
					type: item.type_name,
					slug: item.slug
				})
			})

			setRelatedBlogDetail(blogDetailRaw.data.data.other)
			setBlogDetail(blogDetailRaw.data.data.data)
		}
	},[blogDetailRaw])

	return {
    blogList,
		startBlogList,
		blogPageInfo,
		startBlogDetail,
		blogDetail,
		featuredBlog,
		relatedBlogDetail,
		startFeatureBlogList,
		loadingBlogList,
		loadingFeaturedBlogList,
		loadingBlogDetail
	}
}

export default useBlogQuery
